import { z } from 'zod';

import { WindowKeySchema } from './enums';
import { TickerSchema } from './primitives';

/** ~3Y trading days with headroom; chart may decimate client-side. */
export const BARS_MAX = 2_000;

export const PriceSeriesSchema = z.object({
  ticker: TickerSchema,
  window: WindowKeySchema,
  /** Adjusted close bars, ascending; synthetic length is WN[window]. */
  bars: z.array(z.number()).min(1).max(BARS_MAX),
});
export type PriceSeries = z.infer<typeof PriceSeriesSchema>;

export const SeriesStatsSchema = z.object({
  first: z.number(),
  last: z.number(),
  min: z.number(),
  max: z.number(),
  hi52w: z.number(),
  lo52w: z.number(),
});
export type SeriesStats = z.infer<typeof SeriesStatsSchema>;
